import { render } from "./AddUserRatesModal.vue?vue&type=template&id=07a04e68&ts=true"
import script from "./AddUserRatesModal.vue?vue&type=script&lang=ts"
export * from "./AddUserRatesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__